module.exports = __webpack_public_path__ + "img/infobac.45e0b3c9.png";